import { createUseStyles } from 'react-jss';

const styles = {
  footer: { padding: '8rem 0rem 10rem 0rem', display: 'flex', justifyContent: 'center' },
  saveButton: { marginRight: '1.6rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
